<template>
    <div class="type_taskList" style="background: white;padding: 10px 20px 30px">
        <div>
            <el-row style="margin-top: 15px">
                <el-col :span="12">
                    <span  style="font-weight: bold;margin-right: 10px;display: inline-block;width: 70px">标题</span>
                    <el-input type="text" v-model="selectForm.title" placeholder="请输入任务标题"
                              style="width:calc(100% - 200px)">
                    </el-input>
                </el-col>
                <el-col :span="12" style="position: relative;text-align: left" >
                            <span  style="font-weight: bold;margin-right: 10px;display: inline-block;
                            width: 70px">截止日期
                            </span>
                    <div style="display: inline-block;width: calc(100% - 90px)">
                        <el-date-picker
                                v-model="selectForm.start_date"
                                type="date"
                                format="yyyy-M-d"
                                value-format="yyyy-MM-dd"
                                style="width:46%"
                                placeholder="选择日期"
                        >
                        </el-date-picker><span style="display: inline-block;width: 8%;text-align: center">至
                            </span><el-date-picker
                            v-model="selectForm.end_date"
                            type="date"
                            format="yyyy-M-d"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                            style="width:46%"
                    >
                    </el-date-picker>
                    </div>
                </el-col>
            </el-row>
            <el-row style="margin-top: 20px">
                <el-col :span="12">
                    <span  style="font-weight: bold;margin-right: 10px;display: inline-block;width: 70px">关联对象</span>
                    <el-input type="text" v-model="selectForm.associated" placeholder="请输入关联对象"
                              style="width:calc(100% - 200px)">
                    </el-input>
                </el-col>
                <el-col :span="12" style="height: 40px;line-height: 40px" >
                           <span  style="font-weight: bold;margin-right: 10px;display: inline-block;
                        width: 70px">执行人
                        </span>
                    <el-select v-model="selectForm.owner_id" style="width:calc(100% - 90px)" filterable placeholder="请选择执行人姓名">
                        <el-option
                                v-for="item in performList"
                                :key="item.owner_id"
                                :label="item.owner_name"
                                :value="item.owner_id">
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row style="margin-top: 20px">
                <el-col :span="12" style="height: 40px;line-height: 40px" >
                           <span  style="font-weight: bold;margin-right: 10px;display: inline-block;
                        width: 70px">任务状态
                        </span>
                    <div style="display: inline-block;width: calc(100% - 90px)">
                        <el-checkbox-group style="display: inline-block;"
                                           @change="ladderChange"
                                           v-model="selectForm.checkListArray">
                            <el-checkbox label="T" style="color: #7ED321;">已完成</el-checkbox>
                            <el-checkbox label="F" style="color: #4A90E2">进行中</el-checkbox>
                            <el-checkbox label="E" style="color: #ED3B3F;">已过期</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </el-col>
            </el-row>
            <el-row style="margin-top:101px;border-bottom: 2px dotted rgb(231, 234, 236);padding-bottom: 20px;">
                <el-button type="primary" size="small" @click.stop="handleQueryClick">查询</el-button>
                <el-button type="danger" size="small" @click.stop="handleResetClick">重置</el-button>
            </el-row>
        </div>
        <div>
            <div style="margin-top: 20px;overflow: hidden">
                <div style="float: left;height: 100%;line-height: 50px">
                    <el-button size="small" @click.native="onAddTask" style="background: #4EC880;
                    color: white;border:none">
                        <i class="el-icon-plus" style="color: white"></i>
                        添加待办事项
                    </el-button>
                </div>
                <div style="float: right;">
                  <div style="display: inline-block;text-align: center;border: 2px solid #6BC235;width: 80px;
                  height:50px;padding: 5px;margin-right: 10px">
                      <p style="text-align: left;font-size: 12px;width: 80px;margin-bottom: 8px;
                      margin-top: 5px;color: #6BC235;">本月已完成
                      </p>
                      <span style="font-size: 24px;color: #6BC235;">{{completed}}</span>
                  </div>
                    <div style="display: inline-block;text-align: center;border: 2px solid #4A90E2;width: 80px;
                  height:50px;padding: 5px;margin-right: 10px">
                        <p style="text-align: left;font-size: 12px;width: 80px;margin-bottom: 8px;
                      margin-top: 5px;color: #4A90E2;">进行中
                        </p>
                        <span style="font-size: 24px;color: #4A90E2;">{{unfinished}}</span>
                    </div>
                    <div style="display: inline-block;text-align: center;border: 2px solid #ED3B3F;width: 80px;
                  height:50px;padding: 5px">
                        <p style="text-align: left;font-size: 12px;width: 80px;margin-bottom: 8px;
                      margin-top: 5px;color: #ED3B3F;">已过期
                        </p>
                        <span style="font-size: 24px;color: #ED3B3F;">{{overdue}}</span>
                    </div>
                </div>
            </div>
            <div>
                <el-table
                        :header-cell-style="{'color':'black','font-size':'15px'}"
                        id="taskList_el_Table"
                        :data="tableData"
                        border
                        style="width: 100%;margin-top: 20px"
                        stripe>
                    <el-table-column
                            align="center"
                            fixed
                            type="index"
                            label="序号"
                            width="60px">
                    </el-table-column>
                    <el-table-column
                            min-width="300"
                            prop="title"
                            sortable
                            label="标题"
                            >
                    </el-table-column>
                    <el-table-column
                            min-width="300"
                            prop="text"
                            sortable
                            label="关联对象">
                    </el-table-column>
                    <el-table-column
                            prop="last_name"
                            sortable
                            label="执行人">
                    </el-table-column>
                    <el-table-column
                            width="150"
                            prop="duedate"
                            sortable
                            label="截止日期">
                        <template slot-scope="scope">
                            {{scope.row.duedate|dateFormat}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            width="90"
                            sortable
                            label="状态">
                        <template slot-scope="scope">
                            <div style="text-align: center">
                              <span :style="{color:scope.row.color}">{{scope.row.statusText}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label-class-name="type_taskList_table_cell"
                            fixed="right" label="操作"
                            width="80"
                            style="color: #3b99f7"
                    >
                        <template slot-scope="scope">
                            <div style="text-align: center">
<!--                                <el-button-->
<!--                                        style="background: #FF6F61;border: none;color: white"-->
<!--                                        size="small"-->
<!--                                        @click="deleteTodo(scope.row)">删除-->
<!--                                </el-button>-->
                                <el-button
                                        style="background: #FF9901;border: none;color: white"
                                        size="small"
                                        @click="handleDetail(scope.row)">详情
                                </el-button>
                            </div>

                        </template>
                    </el-table-column>
                </el-table>
                <pagination :page="page" @changePage="changePageClick"></pagination>
            </div>
        </div>

        <el-dialog title="" :visible.sync="dialogVisible" :show-close="false"
                   @close="onCloseDialog()">
            <div slot="title" class="dialog-footer"
                 style="display: flex;justify-content:space-between;
                 border-bottom: 2px dashed #e7eaec;padding:20px 0px">
                <span style="color: #3998F7;font-size: 22px">待办事项</span>
                <span>
                <el-button type="primary" @click="onSaveToto_verify" size="small">保存</el-button>
                <el-button type="danger" @click="dialogVisible = false" size="small">取消</el-button>
                </span>
            </div>
            <el-form ref="todoForm" :rules="rulesTodo" :model="todoForm" label-width="100px" hide-required-asterisk="false"  style="padding: 0 40px">
                <el-form-item label="执行人" prop="perform" class="type_taskList_star">
                    <el-select v-model="todoForm.perform"  style="width: calc(100% - 20px)" :disabled="isDisabled" placeholder="请选择执行人">
                        <el-option
                                v-for="item in performList"
                                :key="item.owner_id"
                                :label="item.owner_name"
                                :value="item.owner_id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="标题" prop="title" class="type_taskList_star">
                    <el-input style="width: calc(100% - 20px)" type="text" :disabled="isDisabled" v-model="todoForm.title"
                              placeholder="请填写标题"></el-input>
                </el-form-item>
                <el-form-item label="截止日期" prop="duedate" class="type_taskList_star">
                    <el-date-picker style="width: calc(100% - 20px)"
                                    format="yyyy-M-d"
                                    value-format="yyyy-MM-dd"
                                    type="date" placeholder="请选择截止日期"
                                    :disabled="isDisabled"
                                    :picker-options="pickerOptions"
                                    v-model="todoForm.duedate">

                    </el-date-picker>
                </el-form-item>
                <el-form-item v-if="isUpdateTodo" label="关联对象" prop="age">
                    <span v-text="todoForm.text" style="color: #4A90E2"></span>
                </el-form-item>
                <el-form-item label="说明" prop="age">
                    <el-input style="width: calc(100% - 20px)" type="textarea"
                              placeholder="请填写说明"
                              :disabled="isDisabled"
                              v-model="todoForm.content"></el-input>
                </el-form-item>
                <el-form-item label="已完成" prop="status">
                    <el-switch
                            v-model="todoForm.done"
                            active-value="T"
                            inactive-value="F"
                            active-color="#13ce66"
                            >
                    </el-switch>
                </el-form-item>
                <el-form-item label="上传照片">
                    <el-upload
                            ref="displayUpload"
                            :limit="9"
                            accept=".jpg,.png,.jpeg"
                            action="/photos/uploadphoto"
                            list-type="picture-card"
                            :on-preview="dialogVisibles"
                            :on-remove="handleRemove"
                            :on-change="handleChange"
                            :on-success="handleImgSuccess"
                            :before-upload="beforeImgUpload"
                            :disabled="isDisabled"
                            :data="displayChecImgData"
                            :file-list="fileList">

                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <p style="line-height:20px">你可以上传多张JPG或PNG格式的图片文件,
                        单个文件大小不能超过20M。</p>
                </el-form-item>
            </el-form>
        </el-dialog>
        <!--        图片放大-->
        <el-dialog :visible.sync="dialogVisibleImg" class="dialogVisibleUp">
            <img width="100%" :src="dialogSrc" alt="">
        </el-dialog>
    </div>
</template>

<script>
    import http from '../../../APIService/http'
    import pagination from '../../../components/pagination'
    import moment from 'moment'
    export default {
        name: "taskList",
        data(){
            return {
                rulesTodo: {
                    title: [
                        { required: true, message: '请输入标题'},
                    ],
                    duedate: [
                        { required: true, message: '请选择截止日期'},
                    ],
                },
                selectForm: {
                    title:'',
                    checkListArray:[],
                    start_date:"",
                    end_date:"",
                    associated:"",
                    owner_id:''
                },
                page:{
                    current: 1,
                    size: 5,
                    total: 0
                },
                completed:'',
                unfinished:'',
                overdue:'',
                tableData:[],
                dialogVisible:false,
                performList:[],
                todoForm:{
                    perform:'',
                    todo_id:"",
                    title:"",
                    duedate:"",
                    content:"",
                    reference_obj:"",
                    reference_id:"",
                    done:"F",
                    distributor_name:"",
                    statusText:"",
                    text:"",
                    color:""
                },
                isUpdateTodo:false,
                displayChecImgData:{
                    reference_obj: 'CLIENT',
                    reference_id: 'com.saasyun.android',
                    credential: '0a4da4e6-e36a-4e78-b4fc-78bb62aa9ff4',
                    tenant_id: this.$store.getters.getUser.tenant_id,
                    username:this.$store.getters.getUser.username,
                    user_id:this.$store.getters.getUser.user_id,
                    event_obj : 'CAMPAIGN',
                    category:'TODO',
                },
                fileList: [],
                copyFileList: [],
                dialogSrc:'',
                dialogVisibleImg:false,
                isDisabled:false,
                pickerOptions:{
                    disabledDate: (time) => {
                        return time.getTime() + 24 * 3600 * 1000 < Date.now() || time.getTime() > Date.now() + 30*24 * 3600 * 1000
                    }
                }

            }
        },
        components: {
            pagination
        },
        created(){
            this.getPerformList()
        },
        filters:{
            dateFormat:function (date) {
                return moment(date).format('YYYY年M月D日')
            }
        },
        mounted(){
          this.init()
        },
        methods: {
            getPerformList(){
                let user = this.$store.getters.getUser
                let data = {
                    user_id : user.user_id,
                    tenant_id : user.tenant_id,
                    role : user.role,
                }
                http.post('/wapi/todo_controller/getPerformList',data).then(res=>{

                        this.performList = []
                        this.performList = res.data
                        this.performList.unshift({owner_name:user.alias,owner_id:user.user_id})
                        this.todoForm.perform = user.user_id

                })
            },
            dialogVisibles(file) {
                this.dialogSrc = file.url
                this.dialogVisibleImg = true
            },
            handleRemove(file, fileList) {
                this.fileList = fileList
            },
            handleChange(file, fileList){
                this.fileList = fileList
                console.log(this.fileList)
            },
            // 上传图片成功
            handleImgSuccess(response, file, fileList) {
                // console.log(file)
                // this.fileList.push({
                //     name: file.name,
                //     url: file.url,
                //     response : file.response
                // });
                // this.editInventoryInfo()
            },
            beforeImgUpload(file) {


                const isPic = file.type === 'application/x-jpg' || file.type === 'image/jpeg' || file.type === 'application/x-png' || file.type === 'image/png'
                const isLt20M = file.size / 1024 / 1024 < 20 * 1.2
                this.file_size = file.size

                if (!isPic) {
                    this.error('上传图片只能是 jpg 或png 格式!')
                }
                if (!isLt20M) {
                    this.error('上传图片大小不能超过 20MB!')
                }
                const nameArr = file.name.split('.')
                return isPic && isLt20M
            },
            ladderChange(){
                if (this.selectForm.checkListArray.length>1){
                    this.selectForm.checkListArray.shift()
                }
            },
            onSaveToto_verify(){
                this.$refs["todoForm"].validate(valid=>{
                    if(!valid){
                        return false
                    }else {
                        let onoff = true
                        for (let i=0;i<this.fileList.length;i++){
                            if (this.fileList[i].status !== "success") {
                                onoff = false
                                break
                            }
                        }
                        if (onoff){
                            this.onSaveToto()
                        } else {
                            this.$message({
                                 type:'warning',
                                 message: '请等待图片上传完成后重试'
                                })
                        }
                    }
                })

            },
            async onSaveToto(){
                try {
                    let user = this.$store.getters.getUser

                    let data = this.todoForm
                    data.tenant_id = user.tenant_id
                    data.user_id = user.user_id
                    data.type = 'addUpdate'
                    data.fileList = this.fileList


                    data.imageIdArray = []   //需要添加图片的数组
                    data.deleteImageIdArray = []  //需要删除图片的数组

                    let imgArrayList = []
                    let copyFileList = this.copyFileList //拿没有新增和删除之前的图片数组

                    //处理数组  找出所有添加图片的数组
                    for (let i=0;i<this.fileList.length;i++){
                        if (this.fileList[i].response){   //如果有 response 这个属性则为添加的图片
                            let obj = this.fileList[i].response.data
                            data.imageIdArray.push(obj)
                        } else {
                            imgArrayList.push(this.fileList[i])
                        }

                    }

                    //处理数组  找出所有删除图片的数组
                    for(var i = 0; i < copyFileList.length; i++){
                        var obj = copyFileList[i];
                        var num = obj.photo_id;
                        var flag = false;
                        for(var j = 0; j < imgArrayList.length; j++){
                            var aj = imgArrayList[j];
                            var n = aj.photo_id;
                            if(n === num){
                                flag = true;
                                break;
                            }
                        }
                        if(!flag){
                            data.deleteImageIdArray.push(obj);
                        }
                    }

                    await http.post('/wapi/todo_controller/addOrEditTodoInfo',data).then(res=>{
                        if (res.success === true){
                            this.dialogVisible = false

                            this.$message({
                                type:'success',
                                message:'保存成功'
                            })
                            this.fileList = []
                            this.init()
                        }
                    })

                }catch (e) {

                }
            },
            onCloseDialog(){
                this.todoForm={
                        todo_id:"",
                        title:"",
                        duedate:"",
                        content:"",
                        reference_obj:"",
                        reference_id:"",
                        done:"F",
                        distributor_name:"",
                        statusText:"",
                        text:"",
                        color:""
                }
                this.$refs['todoForm'].resetFields();
                this.fileList = []
                this.copyFileList = []
            },
            handleDetail(item){
                let user = this.$store.getters.getUser
                if(item.created_by != user.user_id){
                    this.isDisabled = true
                }




                this.isUpdateTodo = true
                this.dialogVisible = true
                this.todoForm = JSON.parse(JSON.stringify(item));
                this.fileList = item.photoList
                this.copyFileList = JSON.parse(JSON.stringify(item.photoList))
            },
            deleteTodo(item){
                this.$confirm('此操作将删除该待办事项, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let user = this.$store.getters.getUser
                    let data = item
                    data.type = 'del'
                    data.tenant_id = user.tenant_id
                    data.user_id = user.user_id
                    http.post('/wapi/todo_controller/addOrEditTodoInfo',data).then(res=>{
                        if (res.success){
                            this.init()
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                        }else {

                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            onAddTask(){
                this.isDisabled = false
                let user = this.$store.getters.getUser
                this.todoForm.perform = user.user_id
                this.isUpdateTodo = false
                this.dialogVisible = true

            },
            onSubmit() {
                console.log('submit!');
            },
            changePageClick(page, size) {
                if (page) {
                    this.page.current = page
                }
                if (size) {
                    this.page.size = size
                }
                this.init()
            },
           async init(){
               let loading = this.$loading({
                   lock: true,
                   text: '拼命加载中',
                   spinner: 'el-icon-loading',
                   background: 'rgba(0, 0, 0, 0.7)'
               });
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        user_id : user.user_id,
                        tenant_id : user.tenant_id,
                        limit: this.page.size,
                        offset: this.page.current - 1,
                        title : this.selectForm.title,
                        checkListArray : this.selectForm.checkListArray,
                        owner_id : this.selectForm.owner_id,
                        start_date : this.selectForm.start_date ? this.selectForm.start_date : '',
                        end_date : this.selectForm.end_date ? this.selectForm.end_date : '',
                        associated : this.selectForm.associated,
                    }
                    await http.post('/wapi/todo_controller/getTodoList',data).then(res=>{
                        if (res.success === true){
                            console.log(res)
                            this.completed = res.data.completed
                            this.unfinished = res.data.unfinished
                            this.overdue = res.data.overdue
                            this.beingData(res.data.array)
                            this.page.total = res.data.arrayCount
                            loading.close()
                        }else {
                            loading.close()
                        }
                    })
                    loading.close()
                }catch (e) {
                    loading.close()
                }
            },
            beingData(array){
                for (let i=0;i<array.length;i++){
                    array[i].text = ''
                    if (array[i].reference_obj === 'HCP') {
                        if (array[i].institution_name) {
                            array[i].text = array[i].institution_name +' | '+array[i].dept_name + ' | ' + array[i].hcp_name
                        }else {
                            array[i].text = ''
                        }

                    }else if (array[i].reference_obj === 'DISTRIBUTOR') {
                        array[i].text = array[i].distributor_name
                    }else if (array[i].reference_obj === 'INSTITUTION'){
                        array[i].text = array[i].institution_name
                    }

                    if (array[i].statusText === '已完成'){
                        array[i].color = '#7ED321'
                    }
                    if (array[i].statusText === '进行中'){
                        array[i].color = '#4A90E2'
                    }
                    if (array[i].statusText === '已过期'){
                        array[i].color = '#ED3B3F'
                    }
                }
                //获取图片
                for(let k=0;k<array.length;k++){
                    let photoList = array[k].photoList
                    for (let j = 0; j<photoList.length;j++ ){
                        this.getImgUrl(photoList[j].photo_id,photoList[j].created_date,photoList[j],photoList)
                    }

                }
                this.tableData = array

            },
            //通过图片id获取图片
            async getImgUrl(id,date,item,arr) {
                try {
                    let data = {
                        reference_obj: 'INSTITUTION',
                        reference_id: 'com.saasyun.android',
                        credential: '0a4da4e6-e36a-4e78-b4fc-78bb62aa9ff4',
                        photo_ids: id,
                        tenant_id: this.$store.getters.getUser.tenant_id
                    }
                    let res = await http.post('/photos/downloadphotos', data)
                    let array = res.data
                    item.url = array[0].thu_url
                    console.log(arr)
                    this.sortKey(arr, "created_date")
                    this.$forceUpdate()

                } catch (err) {
                    console.log(`error:${err}`)
                }
            },
            sortKey(array, key) {
                return array.sort(function(a, b) {
                    var x = a[key];
                    var y = b[key];
                    return x > y ? 1 : x < y ? -1 : 0;
                });
            },
            handleQueryClick(){
                this.page.current = 1
                this.init()
            },
            handleResetClick() {
                this.selectForm={
                        title:'',
                        checkListArray:[],
                        start_date:"",
                        end_date:"",
                        associated:"",
                    owner_id:''
                }
            },
        }
    }
</script>

<style scoped>
    .type_taskList{

    }
    .type_taskList >>>.el-form-item__label{
        font-size: 14px;
        color: #000000;
        text-align: left;
        font-weight: bold;
        padding-right: 30px;
    }
    .type_taskList >>> .type_taskList_table_cell{
        color: #2b92fa !important;
    }
    .type_taskList >>> .type_taskList_star label:after{
        content: '*';
        color: #F56C6C;
        margin-left: 4px;
    }
    .type_taskList >>> .el-dialog__body{
        padding: 20px;
    }
    /*.type_taskList >>> .el-button--warning {*/
    /*    color: #FFF;*/
    /*    background-color: #FF9901;*/
    /*    border-color: #FF9901;*/
    /*}*/
    /*.type_taskList >>> .el-button--warning:hover {*/
    /*    background: #ebb563;*/
    /*    border-color: #ebb563;*/
    /*    color: #FFF;*/
    /*}*/
</style>



// WEBPACK FOOTER //
// src/pages/task/components/taskList.vue